import bizFirstFavicon from '../../../bizfirst-common-themes/images/BizFirstAiLogoMobileDark.png'

/**
 * Sets the browser-tab icon to the shared BizFirst favicon (the one Flow Studio uses).
 * Call once at app startup. Replaces any icon link already in the page, so apps need
 * no copy of the image and no icon link in index.html.
 */
export function applyBizFirstFavicon(): void {
  if (typeof document === 'undefined') return
  document.querySelectorAll<HTMLLinkElement>("link[rel~='icon']").forEach((link) => link.remove())
  const link = document.createElement('link')
  link.rel = 'icon'
  link.type = 'image/png'
  link.href = bizFirstFavicon
  document.head.appendChild(link)
}
